<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
        <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
        </div>
        <div class="mb-2 mt-2 pt-3">
            <button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索" @search="searchEvent" :showGj="true">
                 <template #left>
            <el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" v-auth="'add'+auth_val">添加</el-button>
        </template>
                <template #from>
                    <el-form inline ref="form" :model="from" label-width="100px">
                        <el-form-item label="用户名称" class="mb-0">
                            <el-input size="small" v-model="from.name" placeholder="搜索用户名称"></el-input>
                        </el-form-item>
                        <el-form-item label="创建时间" size="small" class="mb-0">
                            <el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
                             range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-form-item>

                        <el-form-item class="mb-0">
                            <el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
                            <el-button size="small" @click="clearSearch">清空筛选条件</el-button>
                        </el-form-item>
                    </el-form>
                </template>
            </button-search>
        </div>
        

        <!-- 表格 -->
        <div class="mt-3 pt-2">
            <el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
                
                <el-table-column align="center" prop="name" label="用户名称"></el-table-column><el-table-column align="center" prop="account" label="分销账号"></el-table-column><el-table-column align="center" prop="contact_time" label="关联时间"></el-table-column><el-table-column align="center" prop="money_limit" label="额度"></el-table-column><el-table-column align="center" prop="money" label="剩余额度"></el-table-column><el-table-column align="center" prop="arrears" label="欠费天数"></el-table-column><el-table-column align="center" prop="rebate" label="折扣"></el-table-column><el-table-column align="center" prop="cloud_status" label="实例状态"></el-table-column><el-table-column align="center" prop="order_status" label="下单控制"></el-table-column><el-table-column align="center" prop="status" label="账号状态"></el-table-column><el-table-column align="center" prop="msg" label="备注"></el-table-column>
                <el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="140" label="操作">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button @click="openModel(scope.row)"  v-auth="edit" size="mini" plain type="primary">修改</el-button>
                            <el-button @click="deleteItem(scope.row)" v-auth="'del'+auth_val" size="mini" plain type="danger">刪除</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
        </div>


        <div style="height: 60px;"></div>
        <el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
            <!-- 底部 -->
            <div style="flex: 1;" class="px-2">
                <el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
                 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
                </el-pagination>
            </div>
        </el-footer>

        <el-dialog  :close-on-click-modal="false" 
            :title="editIndex > -1 ? '修改' : '添加'"
            :visible.sync="createModel" 
            top="5vh" 
            :width="layout.is_phone ? '90%' : '50%'">
            
            <div style="max-height: 65vh; overflow: auto;">
                <!-- 表單内容 -->
                <el-form :rules="rules" ref="form" :model="form" 
                    :label-width="layout.is_phone ? '80px' : '100px'" 
                    :label-position="layout.is_phone ? 'top' : 'left'">
                    <el-form-item label="用户名称" prop="name"><el-input type="text" v-model="form.name" placeholder="用户名称" clearable size="small" style="width: 85%;"></el-input></el-form-item><el-form-item label="分销账号" prop="account"><el-input type="text" v-model="form.account" placeholder="分销账号" clearable size="small" style="width: 85%;"></el-input></el-form-item><el-form-item label="额度" prop="money_limit"><el-input type="text" v-model="form.money_limit" placeholder="额度" clearable size="small" style="width: 85%;"></el-input></el-form-item><el-form-item label="剩余额度" prop="money"><el-input type="text" v-model="form.money" placeholder="剩余额度" clearable size="small" style="width: 85%;"></el-input></el-form-item><el-form-item label="欠费天数" prop="arrears"><el-input type="text" v-model="form.arrears" placeholder="欠费天数" clearable size="small" style="width: 85%;"></el-input></el-form-item><el-form-item label="折扣" prop="rebate"><el-input type="text" v-model="form.rebate" placeholder="折扣" clearable size="small" style="width: 85%;"></el-input></el-form-item><el-form-item label="实例状态" prop="cloud_status"><el-input type="text" v-model="form.cloud_status" placeholder="实例状态" clearable size="small" style="width: 85%;"></el-input></el-form-item><el-form-item label="下单控制" prop="order_status"><el-input type="text" v-model="form.order_status" placeholder="下单控制" clearable size="small" style="width: 85%;"></el-input></el-form-item><el-form-item label="账号状态" prop="status"><el-input type="text" v-model="form.status" placeholder="账号状态" clearable size="small" style="width: 85%;"></el-input></el-form-item><el-form-item label="备注" prop="msg"><el-input type="text" v-model="form.msg" placeholder="备注" clearable size="small" style="width: 85%;"></el-input></el-form-item>
                </el-form>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="createModel = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>
<script>
    import { commondecrypt } from '@/main';
    import common from '@/common/mixins/common.js';
    import buttonSearch from '@/components/common/button-search.vue';
    
    export default {
        components: {
            buttonSearch
        },

        inject: ['layout', 'app'],
        mixins: [common],

        data() {
            return {
                createModel: false,
                editIndex: -1,
                //搜索數据
                from: {
                    name: '',
                    time: [],
                },

                model_title: 'UserAl',
                auth_val: 'UserAl',
                
                preUrl: "data/UserAlList", //列表
                addUrl: "data/addUserAl", //修改
                delAllUrl: "data/delUserAlAll", //批量删除
                delUrl: "data/delUserAl", //删除單条
                editStatusUrl: "data/editStatusUserAl", //修改狀態

                tableData: [],

                form: {
                    id: 0,
                },

                prop: 'create_time',
                sort: 'descending',
                rule_list: [],
                total_list: [],
                
                rules: {
                    name: [{
                            required: true,
                            message: "用户名称不能为空",
                            trigger: 'blur',
                        },
                    ],account: [{
                            required: true,
                            message: "分销账号不能为空",
                            trigger: 'blur',
                        },
                    ],money_limit: [{
                            required: true,
                            message: "额度不能为空",
                            trigger: 'blur',
                        },
                    ],money: [{
                            required: true,
                            message: "剩余额度不能为空",
                            trigger: 'blur',
                        },
                    ],arrears: [{
                            required: true,
                            message: "欠费天数不能为空",
                            trigger: 'blur',
                        },
                    ],rebate: [{
                            required: true,
                            message: "折扣不能为空",
                            trigger: 'blur',
                        },
                    ],cloud_status: [{
                            required: true,
                            message: "实例状态不能为空",
                            trigger: 'blur',
                        },
                    ],order_status: [{
                            required: true,
                            message: "下单控制不能为空",
                            trigger: 'blur',
                        },
                    ],status: [{
                            required: true,
                            message: "账号状态不能为空",
                            trigger: 'blur',
                        },
                    ],msg: [{
                            required: true,
                            message: "备注不能为空",
                            trigger: 'blur',
                        },
                    ],
                },
            
            }
        },
        methods: {
            handleClick(tab, event) {
                this.search = ''
                this.clearSearch()
                this.getList()
            },
            sortChange(column) {
                this.prop = column.prop
                this.sort = column.order
                this.getList()
            },
            handleAvatarSuccess(res, file) {
                this.form.img = URL.createObjectURL(file.raw);
                let en_data = commondecrypt(res.encryption)
                res.encryption = JSON.parse(en_data)
                if(res.encryption.code==1){
                    this.form.head = res.encryption.data.list.url
                }
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 2;
                return isJPG && isLt2M;
            },
            // 打开模态框
            openModel(e) {
                if(e){
                    this.form = {
                        name:  e.name,account:  e.account,money_limit:  e.money_limit,money:  e.money,arrears:  e.arrears,rebate:  e.rebate,cloud_status:  e.cloud_status,order_status:  e.order_status,status:  e.status,msg:  e.msg,
                    }
                    
                    this.editIndex = e.id
                }else{
                    this.form = {
                        name: '',account: '',money_limit: '',money: '',arrears: '',rebate: '',cloud_status: '',order_status: '',status: '',msg: '',
                    }
                    this.editIndex = -1
                }
                
                // 打开dialog
                this.createModel = true
            },

            //前往修改页面
            editItem(obj) {
                this.$router.push({
                    name: 'set_manager_rule',
                    query: {
                        item: obj
                    }
                })
            },
            getListResult(e) {
                this.tableData = e.list
                this.total_list = e.total_list
                this.check_img_list = e.list.map(item => {
                    return item.head
                })
            },
            // 清空篩選條件
            clearSearch() {
                this.from = {
                    name: '',
                    time: [],
                }

                this.$refs.buttonSearch.closeSuperSearch()
                this.search = ''
                this.getList()
            },
            // 選擇图片
            chooseImage() {
                this.app.chooseImage((res) => {
                    this.$set(this.form, 'headUrl', res[0].url);
                    this.form['headId'] = res[0].id
                    this.$set(this.form, 'headId', res[0].id);
                }, 1)
            }
        }
    }
</script>